import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const SystemNotificationPanel = ({ onSendNotification }) => {
  const [notificationData, setNotificationData] = useState({
    subject: '',
    message: '',
    recipientType: 'all',
    priority: 'normal',
    includeEmail: true,
    includeDashboard: true
  });

  const recipientOptions = [
    { value: 'all', label: 'All Users' },
    { value: 'active', label: 'Active Users Only' },
    { value: 'pending', label: 'Pending Audits' },
    { value: 'custom', label: 'Custom Selection' }
  ];

  const priorityOptions = [
    { value: 'high', label: 'High Priority' },
    { value: 'normal', label: 'Normal' },
    { value: 'low', label: 'Low Priority' }
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSendNotification(notificationData);
    setNotificationData({
      subject: '',
      message: '',
      recipientType: 'all',
      priority: 'normal',
      includeEmail: true,
      includeDashboard: true
    });
  };

  return (
    <div className="bg-card rounded-lg shadow-md border border-border">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-accent/10">
            <Icon name="Bell" size={20} color="var(--color-accent)" />
          </div>
          <h2 className="text-lg md:text-xl font-semibold text-foreground">System Notifications</h2>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="p-4 md:p-6 space-y-4 md:space-y-6">
        <Input
          label="Subject"
          type="text"
          placeholder="Enter notification subject..."
          value={notificationData?.subject}
          onChange={(e) => setNotificationData({ ...notificationData, subject: e?.target?.value })}
          required
        />

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Message</label>
          <textarea
            className="w-full px-4 py-3 bg-input border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-smooth resize-none"
            rows="6"
            placeholder="Enter notification message..."
            value={notificationData?.message}
            onChange={(e) => setNotificationData({ ...notificationData, message: e?.target?.value })}
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            label="Recipients"
            options={recipientOptions}
            value={notificationData?.recipientType}
            onChange={(value) => setNotificationData({ ...notificationData, recipientType: value })}
          />

          <Select
            label="Priority"
            options={priorityOptions}
            value={notificationData?.priority}
            onChange={(value) => setNotificationData({ ...notificationData, priority: value })}
          />
        </div>

        <div className="space-y-3">
          <p className="text-sm font-medium text-foreground">Delivery Channels</p>
          <Checkbox
            label="Send Email Notification"
            checked={notificationData?.includeEmail}
            onChange={(e) => setNotificationData({ ...notificationData, includeEmail: e?.target?.checked })}
          />
          <Checkbox
            label="Show in User Dashboard"
            checked={notificationData?.includeDashboard}
            onChange={(e) => setNotificationData({ ...notificationData, includeDashboard: e?.target?.checked })}
          />
        </div>

        <div className="flex flex-col sm:flex-row gap-3 pt-4">
          <Button
            type="submit"
            variant="default"
            iconName="Send"
            fullWidth
            className="sm:flex-1"
          >
            Send Notification
          </Button>
          <Button
            type="button"
            variant="outline"
            iconName="Eye"
            fullWidth
            className="sm:flex-1"
          >
            Preview
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SystemNotificationPanel;